// import { BravadoCardItem } from '~/components/partials/landings/ui/BravadoItemCard.vue';
// import { BravadoAvatarItem } from '~/components/partials/landings/ui/BravadoAvatar.vue';
import type { VueConstructor } from 'vue';
import type Vue from 'vue';

type BravadoAvatarItem = {
  image: string;
  name: string;
  title: string;
};

type BravadoCardItem = {
  logo?: VueConstructor<Vue>;
  image?: string;
  title: string;
  subtitle: string;
  color:
    | 'platinum-linear'
    | 'silver-linear'
    | 'gold-linear'
    | 'purple-linear'
    | 'cyan-gradient'
    | 'purple-hover'
    | 'purple-1'
    | 'purple-3'
    | 'purple-4'
    | 'cyan-0'
    | 'cyan-1'
    | 'cyan-2'
    | 'cyan-3'
    | 'brand';
  badge?: string;
  points?: string[];
  animation?: string;
  link?: string;
};

export const sales: Array<BravadoCardItem> = [
  {
    image: require('~/components/partials/landings/about-us/images/people/michelle.webp'),
    animation: 'fade-right',
    title: 'Michelle Pitt',
    subtitle: 'entry level SDR',
    color: 'platinum-linear',
    badge: '🐤 Newcomer',
    points: [
      'Gets sales advice in Bravado War Room',
      'Learns sales tips in Academy',
      'Finds mentorship from other members',
    ],
  },
  {
    image: require('~/components/partials/landings/about-us/images/people/michael.webp'),
    animation: 'fade-up',
    title: 'Michael Wade',
    subtitle: 'experienced enterprise AE',
    color: 'silver-linear',
    badge: '💼 Proficient',
    points: [
      'Uses Bravado’s comp guide to negotiate a raise',
      'Celebrates him first deal closed in the War Room',
      'Finds a better-paying role Senior AE role through Bravado Jobs',
    ],
  },
  {
    image: require('~/components/partials/landings/about-us/images/people/demi.webp'),
    animation: 'fade-left',
    title: 'Demi Brown',
    subtitle: 'VP of sales at a growing startup',
    color: 'gold-linear',
    badge: '👑 Expert',
    points: [
      'Mentors rising sales talent',
      'Leverages Seller Portfolio to network with other sales leaders',
      'Uses Bravado talent to hire a superstar sales team',
    ],
  },
];

export const team: Array<BravadoAvatarItem> = [
  {
    image: require('~/components/partials/landings/about-us/images/team/sahil.webp'),
    name: 'Sahil Mansuri',
    title: 'CEO',
  },
  {
    image: require('~/components/partials/landings/about-us/images/team/amy.webp'),
    name: 'Amy Young',
    title: 'VP Operations',
  },
  {
    image: require('~/components/partials/landings/about-us/images/team/lisa.webp'),
    name: 'Lisa Zhu',
    title: 'VP Product',
  },
  {
    image: require('~/components/partials/landings/about-us/images/team/yoni.webp'),
    name: 'Yoni Acriche',
    title: 'Chief Data Scientist',
  },
  {
    image: require('~/components/partials/landings/about-us/images/team/anton.webp'),
    name: 'Anton Pleshivtsev',
    title: 'VP Engineering',
  },
  {
    image: require('~/components/partials/landings/about-us/images/team/alex.webp'),
    name: 'Alex Shevenionov',
    title: 'Head of Design',
  },
];

export const medias: Array<BravadoCardItem> = [
  {
    logo: require('~/components/partials/landings/about-us/images/logos/techcrunch-logo.svg'),
    animation: 'fade-right',
    title: 'Sales professionals get a bad rap – Bravado wants to change that',
    subtitle: 'TECHCRUNCH',
    color: 'purple-linear',
    link: 'https://techcrunch.com/2019/07/24/bravado/?guccounter=1',
  },
  {
    logo: require('~/components/partials/landings/about-us/images/logos/business-insider-logo.svg'),
    animation: 'fade-up',
    title: 'Bravado CEO interview on $8.5 million Series A round',
    subtitle: 'BUSINESS INSIDER',
    color: 'cyan-gradient',
    link: 'https://www.businessinsider.com/bravado-ceo-series-a-investment-sales-2019-7',
  },
  {
    logo: require('~/components/partials/landings/about-us/images/logos/business-insider-logo.svg'),
    animation: 'fade-left',
    title: 'Bravado emerges from stealth with $12M in funding for a professional network for sales',
    subtitle: 'BUSINESS INSIDER',
    color: 'purple-hover',
    link: 'https://techstartups.com/2019/07/24/bravado-emerges-stealth-12m-funding-professional-network-sales/',
  },
];
